var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"w-full text-left py-3 flex items-center",attrs:{"to":_vm.to}},[_c('span',{staticClass:"text-responsive-sidebar-link hover:text-responsive-sidebar-link-hover text-xl font-thin"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }